export const state = {
  // Chat sessions by organization ID
  // Structure: { [orgId]: { [sessionCode]: session } }
  sessions: {},

  // Current active session code
  activeSessionCode: null,

  // Messages by session code
  // Structure: { [sessionCode]: [messages] }
  messages: {},

  // Prompts by session code
  // Structure: { [sessionCode]: { organization, system, projects[], layers[] } }
  prompts: {},

  // Available LLM models fetched from backend
  availableModels: []
}
